import { Button } from "@/components/ui/baseUi/button"
import { Text } from "@/components/ui/baseUi/text"
import { cn } from "@/modules/lib/utils"
import { PlusIcon } from "@images/svgIcons/plusIcon"
import { ReturnIcon } from "@images/svgIcons/returnIcon"
import { useBoxSlotTemplateSidebar } from "@modules/boxSlotTemplate/hooks/useBoxSlotTemplateSidebar"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { useCalendar } from "@modules/calendar/hooks/useCalendar"
import { word } from "@modules/core/utils/i18n"
import { useBoxNavigate } from "@modules/navigation/hooks/useBoxNavigate"
import { Path } from "@modules/navigation/routes"
import { useParams } from "react-router"

type BoxTemplateHeaderRightViewProps = {
  className?: string
} & React.ComponentProps<"div">

export function BoxTemplateHeaderRightView({ className, ...props }: BoxTemplateHeaderRightViewProps) {
  const { boxProgramId } = useParams()
  const boxNavigate = useBoxNavigate()
  const { selectedDate } = useCalendar()
  const { navigateToBoxSlotTemplateGroupCreation } = useBoxSlotTemplateSidebar()
  // PERMISSIONS - Head-coach & Coach & Financial permissions denied
  const canManageTypicalWeek = useBoxStaffPermission(BoxStaffPermissions.MANAGE_TYPICAL_WEEK)

  return (
    <div
      className={cn(
        "relative z-1 mb-5 flex h-50 flex-col justify-between gap-2 rounded-4xl bg-surface-foreground p-4",
        className,
      )}
      {...props}
    >
      <Text fontStyle="TM" className="ml-2">
        {word("box.programmation.activity.typicalWeek")}
      </Text>
      {canManageTypicalWeek && (
        <div className="mt-2 flex flex-row items-center justify-center gap-2">
          <Button
            variant="primary"
            size="iconMd"
            onClick={() => {
              if (boxProgramId) {
                navigateToBoxSlotTemplateGroupCreation(boxProgramId)
              }
            }}
          >
            <PlusIcon color="currentColor" width={20} height={20} className="text-textDefault-body" />
          </Button>
          <Text fontStyle="LM" className="text-center">
            {word("box.programmation.activity.newsSlots")}
          </Text>
        </div>
      )}

      <Button
        variant="underline"
        size="sm"
        onClick={() =>
          boxProgramId &&
          boxNavigate(Path.Box.ProgrammationDetails(boxProgramId), {
            state: { selectedDate: selectedDate?.toString() ?? "" },
          })
        }
      >
        <ReturnIcon color="currentColor" width={20} height={20} className="text-textDefault-body" />
        {word("box.backToTimetable")}
      </Button>
    </div>
  )
}
